module.exports = __webpack_public_path__ + "img/drag-list.127b6b88.svg";